import React, {useContext, useState} from "react";
import {useCoinAccountQuery, useCoinAccountTransferQuery} from "../../hook/coin";
import {Amount, Title, Layout, MeTransferButton, Extra, AmountLabel, Card, Overlay, Body} from "./styles";
import {Modal, Table} from "antd";
import {CoinAccountTransfer} from "src/typing/coin";
import dayjs from "dayjs";
import Activation from "../Activation";
import {useGameContactQuery} from "../../hook/verify-mobile";
import UserContext from "../../../component/user/context/UserContext";

interface MyCoinAccountProps {
    name: string;
    label: string;

}


function MyCoinAccount(props: MyCoinAccountProps) {
    const {
        label,
        name,
    } = props;

    const {
        current,
        authenticate
    } = useContext(UserContext);
    const {
        data,
        error,
    } = useCoinAccountQuery(current?.uid, name);


    const [opened, setOpened] = useState<boolean>(false);
    return <Layout>
        <Body>
            <Card>
                <Title>
                    <AmountLabel>
                        我的{label}-平台币
                    </AmountLabel>
                    {!error && data ? <>
                        <Amount>
                            {data?.amount}
                        </Amount>
                        元
                    </> : null}

                </Title>
                <Extra>
                    <MeTransferButton onClick={() => {
                        if (!current) {
                            authenticate();
                            return;
                        }
                        setOpened(true)
                    }}>
                        我的账单
                    </MeTransferButton>
                </Extra>
            </Card>
            {/*<Overlay />*/}

        </Body>


        <Modal
            open={opened}
            footer={false}
            width={680}
            onCancel={() => {
                setOpened(false)
            }}
            title={"我的账单"}
            destroyOnClose
        >
            <MyCoinAccountTransferTable name={name} />
        </Modal>

    </Layout>
}

interface MyCoinAccountTransferTableProps {
    name: string;
}
const TYPE_MAPPING: Record<string, string> = {
    "RECHARGE": "平台币到账",
    "CONSUME": "游戏消费",
}
const CATEGORY_MAPPING: Record<string, string> = {
    "RECHARGE": "平台币到账",
    "GAME_CONSUME": "游戏消费",
    "SYSTEM_DEDUCT": "系统扣除",
    "SYSTEM_GRANT": "系统赠与",
}
function MyCoinAccountTransferTable(props: MyCoinAccountTransferTableProps) {
    const {
        name,
    } = props;
    const {
        isLoading,
        items,
    } = useCoinAccountTransferQuery(name);


    return <Table<CoinAccountTransfer> rowKey={"id"} columns={[
        {
            title: "分类",
            dataIndex: "category",
            width: 200,
            render: (value, record) => {
                return CATEGORY_MAPPING[value]??TYPE_MAPPING[record.type]
            }
        },
        {
            title: "金额",
            dataIndex: "value"
        },
        {
            title: "时间",
            dataIndex: "createdAt",
            render: (value) => {
                return dayjs(value).format("YYYY-MM-DD HH:mm")
                // return <>
                //
                //     {value.createdAt}
                // </>
            }

        }
    ]} dataSource={items} pagination={false}/>
}
export default MyCoinAccount;